module.exports = __webpack_public_path__ + "img/1_2-parcheggio-1-bus.c567e535.png";